
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.558 0H4.44C1.92.084-.06 2.12 0 4.563v13.302c-.025.447.238.862.66 1.043.422.181.917.09 1.24-.23l2.37-2.45A2.456 2.456 0 016 15.5h9.517a4.666 4.666 0 003.235-1.404 4.379 4.379 0 001.244-3.217V4.563C20.059 2.12 18.078.084 15.557 0zM6.25 5.057h4.999c.414 0 .75.325.75.727a.738.738 0 01-.75.726H6.25a.738.738 0 01-.75-.726c0-.402.336-.727.75-.727zm0 5.329h7.498c.414 0 .75-.326.75-.727a.739.739 0 00-.75-.727H6.25a.738.738 0 00-.75.727c0 .401.336.726.75.726z","fill":"#7B01B5"}})])
          )
        }
      }
    